/*
 * VA-29329: the Blog Studio's routing helpers, kept apart from the studio itself so
 * the admin console can import them while the studio itself loads only
 * when a Blog section is opened.
 */
/** Section key in the console ⇄ studio view. */
export const blogViewOf = (key) => key === 'blog' ? 'overview' : key.replace(/^blog\./, '');
export const blogKeyOf = (view) => (view === 'overview' ? 'blog' : `blog.${view}`);
/*
 * The post editor is its own full-screen page, outside the console's chrome:
 *   /admin/blog/posts/new          new post (the console opens it in a new tab)
 *   /admin/blog/posts/<id>/edit    edit a post
 *   /admin/blog/preview            live preview of the editor in another tab
 */
export const BLOG_ADMIN_BASE = '/admin/blog';
export const editorPath = (id) => id ? `${BLOG_ADMIN_BASE}/posts/${encodeURIComponent(id)}/edit` : `${BLOG_ADMIN_BASE}/posts/new`;
export const PREVIEW_PATH = `${BLOG_ADMIN_BASE}/preview`;
/** sessionStorage key for a success message the posts list shows on arrival. */
export const FLASH_KEY = 'vriti.blogStudio.flash';
/** localStorage key the editor writes its preview to; the preview tab listens on it. */
export const PREVIEW_KEY = 'vriti.blogStudio.preview';
/** "New post" opens the editor in its own tab, leaving the list where it was. */
export const openNewPost = () => window.open(editorPath(), '_blank', 'noopener');
/** The console URL for a studio view, e.g. /admin/settings#blog.posts. */
export const consolePath = (view, sub = []) => `/admin/settings#${blogKeyOf(view)}${sub.length ? `/${sub.map(encodeURIComponent).join('/')}` : ''}`;
/** Header title for the editor pages, which have no sidebar entry of their own. */
export function blogPageTitle(key, sub) {
    if (key !== 'blog.posts')
        return undefined;
    if (sub[0] === 'new')
        return 'New post';
    if (sub[0] === 'edit')
        return 'Edit post';
    return undefined;
}
export function blogPageDescription(key, sub) {
    if (key !== 'blog.posts')
        return undefined;
    if (sub[0] === 'new')
        return 'Write, preview and publish. Drafts are never shown on /blog.';
    if (sub[0] === 'edit')
        return 'Changes to a published post go live when you press Update.';
    return undefined;
}
